import { Injectable, signal, Signal } from '@angular/core';
import { WorkOrderWarning } from '@shared/models/supplier/work-order/supplier-work-order-details';
import { TranslatableString } from '@rs-shared-lib/models/translatable-string';
import { isNil } from 'lodash';

@Injectable()
export class ExistingWorkOrderWarningService {
  private readonly _warning = signal<WorkOrderWarning | undefined>(undefined);

  public get warning(): Signal<WorkOrderWarning | undefined> {
    return this._warning.asReadonly();
  }

  public setFromTranslatableString(translatable?: TranslatableString): void {
    if (isNil(translatable)) {
      this._warning.set(undefined);
      return;
    }

    this._warning.set({
      key: 'EXISTING_WORK_ORDER_WARNING',
      title: translatable,
      mandatory: false,
      severity: 'INFO',
    });
  }
}
